/** Подготавливает координату для ввода с фиксированной точностью */
export const formatCoordinateInput = (
    value: number | null | undefined,
    integerDigits: 2 | 3
): string => {
    if (value == null || !Number.isFinite(value)) return '';

    const [integer, fraction] = Math.abs(value).toFixed(7).split('.');

    return `${value < 0
        ? '-'
        : ''}${integer.padStart(integerDigits, '0')}.${fraction}`;
};
